/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
import styled from 'styled-components'
import { useState } from 'react'
import { useProfile } from 'querys/profile'
import { SecondaryButton, OutlineButton } from 'common/button'
import { useUpdateProjectStatus, handleUpdate } from 'mutations/projects'
import { INPROGRESS } from 'utils/project-status'
import Repository from 'icons/repository'
import RepositoriesModal from './repository-update/repositories-form'
import UpdateStack from './update-stack'

const ProjectProgressStyled = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 16px;
  @media(min-width: 768px) {
    grid-template-columns: repeat(2, min-content);
    column-gap: 16px;
  }
`

const fetcher = (url) => fetch(url).then((res) => res.json())

function ProjectProgress({ progressStatus, project }) {
  const { mutate: updateProject, isLoading } = useUpdateProjectStatus()
  const [modal, setModal] = useState(false)
  const [updateStack, setUpdateStack] = useState(false)
  const {
    data: {
      info: {
        discord_username,
        github_username: username,
        github_token: token,
      },
    },
  } = useProfile()

  const {
    project_url, repository_slug, status, stack,
  } = progressStatus

  const disabled = () => {
    if (!discord_username || !username || !token || !status) return true
    return false
  }

  const handleOpen = () => {
    if (disabled()) return
    setModal(true)
  }

  const handleRevision = async () => {
    if (disabled() || isLoading) return
    let stackArr = stack
    if (!project_url || !repository_slug) setModal(true)
    if (stack.length === 0 && project_url && repository_slug) {
      const { topics, description } = await fetcher(`/api/github/repo?repo=${repository_slug}&username=${username}`)
      if (topics.length !== 0 || !description) {
        setUpdateStack(false)
        stackArr = topics
      } else {
        setUpdateStack(true)
        return
      }
    }
    // Pedir los datos actualizados a github si hay url pero no stack
    handleUpdate({
      project,
      project_url,
      repository_slug,
      stack: stackArr,
      mutation: updateProject,
    })
  }

  if (!repository_slug) {
    return (
      <>
        <RepositoriesModal modal={modal} project={project} setModal={setModal} username={username} />
        <SecondaryButton onClick={() => handleOpen()} disabled={disabled()} fullWidth fitContent responsive>
          <Repository margin="0 8px 0 0" color="var(--white)" />
          Vincular repositorio
        </SecondaryButton>
      </>
    )
  }

  return (
    <>
      {updateStack && (
        <UpdateStack repo={repository_slug} name={repository_slug} />
      )}
      <ProjectProgressStyled>
        <RepositoriesModal modal={modal} project={project} setModal={setModal} username={username} />
        {status === INPROGRESS && (
          <SecondaryButton
            onClick={() => handleRevision()}
            disabled={disabled() || isLoading}
            fullWidth fitContent responsive
          >
            {project_url
              ? (isLoading ? 'Mandando a revisión...' : 'Solicitar nueva revisión')
              : 'Solicitar revisión'
            }
          </SecondaryButton>
        )}
        <OutlineButton onClick={() => handleOpen()} disabled={disabled()} fullWidth fitContent responsive>
          <Repository margin="0 8px 0 0" color="var(--baseFullContrast)" />
          Actualizar repositorio
        </OutlineButton>
      </ProjectProgressStyled>
    </>
  )
}

export default ProjectProgress
